import React from 'react';

const ContactsListConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_CONTACT', 'ROLE_CONTACT_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/contacts',
      exact: true,
      component: React.lazy(() => import('./contacts_list'))
    }
    // {
    //     path     : '/contact/import',
    //     exact    : true,
    //     component: React.lazy(() => import('./contacts_import/'))
    // },
  ]
};

const OriginsListConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_ORIGIN', 'ROLE_ORIGIN_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/contact/origins',
      exact: true,
      component: React.lazy(() => import('./contacts_origin'))
    }
  ]
};

const OriginsAddConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_ORIGIN', 'ROLE_ORIGIN_ADD', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/contact/origin/add',
      component: React.lazy(() => import('./contacts_origin_edit'))
    }
  ]
};

const OriginsEditConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_ORIGIN', 'ROLE_ORIGIN_EDIT', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/contact/origin/:id',
      component: React.lazy(() => import('./contacts_origin_edit'))
    }
  ]
};

export {
  ContactsListConfig,
  OriginsListConfig,
  OriginsAddConfig,
  OriginsEditConfig
};
